import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  InputNumber,
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  FullscreenOutlined,
  CameraOutlined,
  AuditOutlined,
  SkinOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

// STATUS
const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

// SEXO
const options_sexo = [
  { value: "M", label: "Masculino" },
  { value: "F", label: "Feminino" },
];

// AJUSTE
const options_ajuste = [
  { value: 1, label: "Sim" },
  { value: 0, label: "Não" },
];

// STATUS
const options_status_filter = [
  { value: 999, label: "Todos" },
  { value: 0, label: "Inativos" },
  { value: 1, label: "Ativos" },
];

export const UniformesCadProdutos = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);

  // FORNECEDORES
  const [fornecedores, setFornecedores] = useState([]);
  const [search, setSearch] = useState("");
  const [filtroStatus, setFiltroStatus] = useState(1);

  useEffect(() => {
    listarProdutos();
    listarFornecedores();
  }, []);

  // LISTAR FORNECEDORES
  const listarFornecedores = async () => {
    setLoading(true);
    const api = await http("get", `v1/fornecedores/listar_ativos`, []);
    if (api.statusCode === 200) {
      let options_fornecedores = [];
      for (const f of api.response.data) {
        options_fornecedores.push({ value: f.id, label: f.descricao });
      }
      setFornecedores(options_fornecedores);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarProdutos = async () => {
    setLoading(true);
    const api = await http("get", `v1/uniformes_produtos/listar`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarProduto = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/uniformes_produtos/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarProdutos();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarProduto = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/uniformes_produtos/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarProdutos();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarProduto = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/uniformes_produtos/carregar/${id}`, []);

    if (api.statusCode === 200) {
      setShowModal(true);
      resetForm();
      form.setFieldsValue({
        descricao: api.response.data.descricao,
        codigo: api.response.data.codigo,
        valor: api.response.data.valor,
        id_uniformes_cad_fornecedores: api.response.data.id_uniformes_cad_fornecedores,
        sexo: api.response.data.sexo,
        ajuste_altura: api.response.data.ajuste_altura,
        ajuste_manga: api.response.data.ajuste_manga,
        status: api.response.data.status,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarProduto = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/uniformes_produtos/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarProdutos();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Código",
      dataIndex: "codigo",
      sorter: (a, b) => a.codigo?.toString()?.localeCompare(b.codigo?.toString()),
    },
    {
      title: "Descrição",
      dataIndex: "descricao",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      title: "Fornecedor",
      dataIndex: "fornecedor",
      sorter: (a, b) => a.fornecedor?.localeCompare(b.fornecedor),
    },
    {
      title: "Valor",
      dataIndex: "valor",
      sorter: (a, b) => a.valor?.toString()?.localeCompare(b.valor?.toString()),
    },
    {
      title: "Ajuste Manga",
      dataIndex: "ajuste_manga",
      render: (_, e) => (e.ajuste_manga === 1 ? "Sim" : "Não"),
      sorter: (a, b) => (a.ajuste_manga === 1 ? "Sim" : "Não")?.localeCompare(b.ajuste_manga === 1 ? "Sim" : "Não"),
    },
    {
      title: "Ajuste Altura",
      dataIndex: "ajuste_altura",
      render: (_, e) => (e.ajuste_altura === 1 ? "Sim" : "Não"),
      sorter: (a, b) => (a.ajuste_altura === 1 ? "Sim" : "Não")?.localeCompare(b.ajuste_altura === 1 ? "Sim" : "Não"),
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 90,
      render: (_, e) => (e.status === 1 ? "Ativo" : "Inativo"),
      sorter: (a, b) => (a.status === 1 ? "Ativo" : "Inativo")?.localeCompare(b.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      title: "Ações",
      width: 150,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Tamanhos">
            <Button
              loading={loading}
              onClick={() => navigate(`/uniformes/gestao-produtos/tamanhos/${e.id}`)}
              icon={<FullscreenOutlined />}
            />
          </Tooltip>

          <Tooltip title="Imagens">
            <Button
              loading={loading}
              onClick={() => navigate(`/uniformes/gestao-produtos/imagens/${e.id}`)}
              icon={<CameraOutlined />}
            />
          </Tooltip>

          <Tooltip title="Cargos">
            <Button
              loading={loading}
              onClick={() => navigate(`/uniformes/gestao-produtos/cargos/${e.id}`)}
              icon={<AuditOutlined />}
            />
          </Tooltip>

          <Tooltip title="Editar">
            <Button loading={loading} onClick={() => carregarProduto(e.id)} icon={<EditOutlined />} />
          </Tooltip>

          <Tooltip title="Excluir">
            <Button
              loading={loading}
              icon={<DeleteOutlined />}
              onClick={() => {
                modal.confirm({
                  title: "Deseja deletar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    deletarProduto(e.id);
                  },
                });
              }}
            />
          </Tooltip>
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarProduto(formulario);
    } else {
      cadastrarProduto(formulario);
    }
  };

  // PESQUISAR
  const handleFilter = (pesquisar, status) => {
    let filteredData = dados?.filter(
      (val) =>
        val.descricao?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.codigo?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.fornecedor?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.valor?.toString()?.toLowerCase().includes(pesquisar.toLowerCase())
    );

    if (status !== 999) {
      filteredData = filteredData?.filter((val) => val.status === status);
    }

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search, filtroStatus) : [];

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Produto
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="descricao"
                label="Descrição"
                rules={[{ required: true, message: "Digite a descrição!" }]}>
                <Input size="large" disabled={loading} placeholder="Informe a descrição" />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="codigo" label="Código" rules={[{ required: true, message: "Digite o código!" }]}>
                <InputNumber
                  min={1}
                  precision={0}
                  size="large"
                  disabled={loading}
                  placeholder="Informe o código"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="valor" label="Valor" rules={[{ required: true, message: "Digite o valor!" }]}>
                <InputNumber
                  precision={2}
                  min={0}
                  addonBefore="R$"
                  decimalSeparator=","
                  size="large"
                  disabled={loading}
                  placeholder="Informe o valor"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="id_uniformes_cad_fornecedores"
                label="Fornecedor"
                rules={[{ required: true, message: "Selecione o fornecedor!" }]}>
                <Select
                  showSearch
                  allowClear
                  filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  size="large"
                  placeholder="Selecione o fornecedor"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={fornecedores}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="sexo" label="Sexo" rules={[{ required: true, message: "Selecione o sexo!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o sexo"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_sexo}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="ajuste_manga"
                label="Ajuste de manga"
                rules={[{ required: true, message: "Selecione uma opção!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione uma opção"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_ajuste}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="ajuste_altura"
                label="Ajuste de altura"
                rules={[{ required: true, message: "Selecione uma opção!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione uma opção"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_ajuste}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="status" label="Status" rules={[{ required: true, message: "Selecione o status!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o status"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_status}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Uniformes" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Uniformes Produtos"
              subtitle="Cadastro de Produtos"
              icon={<SkinOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Tooltip title="Adicionar Registro">
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setShowModal(true);
                      resetForm();
                    }}
                    loading={loading}>
                    Novo
                  </Button>
                </Tooltip>

                <Select
                  style={{ minWidth: 180 }}
                  value={filtroStatus}
                  onChange={(e) => setFiltroStatus(e)}
                  options={options_status_filter}
                />
              </Space>

              <Divider />

              <Table rowKey="id" scroll={{ x: 700 }} columns={columns} dataSource={dadosFilter} size="small" />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
